export const DIALOG_STEPS = [
    'Зайдите на сайт или в приложение «Мой налог»',
    'Зайдите в «Зарегистрироваться в качестве самозанятого»',
    'Пройдите регистрацию',
    'После этого нажмите «Проверить»',
];
